// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
import axiosPlugin from "./server"; 
Vue.use(axiosPlugin);
import moment from 'moment'//导入文件 

Vue.prototype.$moment = moment;//赋值使用
// 默认会找 Filters/index.js
import * as filters from './Filters/'

// 遍历所有导出的过滤器并添加到全局过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
})
Vue.config.productionTip = false
import  Base from  './assets/base'
Vue.use(Base);
//引入外部css
import './assets/base.css'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts 

//基础数据
import baseData from '@/assets/js/baseData.js'
Vue.prototype.$BaseData = baseData

import common from '@/assets/js/common.js'
Vue.prototype.$common = common

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js